import { cssVar, mediaQuery } from 'src/app/styles/helper';
import styled, { css } from 'styled-components';
import { StyledColumnProps, columnStyles } from '../Column.styles';
import { StyledSpacingProps, spacingStyles } from '../Spacing.styles';
import { StyledMaxWidthProps, maxWidthStyles } from '../MaxWidth.styles';
import { StyledVisibilityProps, visibilityStyles } from '../Visibility.styles';
import { ColorModePropKeys } from 'src/app/styles/colors';
import { borderStyles } from '../Border.styles';
import { StyledOrderProps, orderStyles } from '../Order.styles';

export type DirectionType = 'row' | 'column' | 'row-reverse' | 'column-reverse';
export type JustifyType = 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around';
export type AlignType = 'flex-start' | 'flex-end' | 'center' | 'stretch';

export interface StackContainerProps
  extends StyledColumnProps,
    StyledSpacingProps,
    StyledMaxWidthProps,
    StyledVisibilityProps,
    StyledOrderProps {
  $direction?: DirectionType;
  $directionSm?: DirectionType;
  $directionMd?: DirectionType;
  $directionLg?: DirectionType;
  $directionXl?: DirectionType;
  $direction2xl?: DirectionType;
  $align?: AlignType;
  $justify?: JustifyType;
  $position?: 'static' | 'relative' | 'absolute' | 'fixed' | 'sticky';
  $background?: ColorModePropKeys;
  $flexWrap?: 'wrap' | 'nowrap';
  $zIndex?: number;
  $fullWidth?: boolean;
}

export const StackContainer = styled.div<StackContainerProps>`
  /* Used on hide/show helpers */
  --layout-display-property: flex;

  display: var(--layout-display-property);

  flex-direction: ${({ $direction = 'row' }) => $direction};
  align-items: ${({ $align = 'stretch' }) => $align};
  justify-content: ${({ $justify = 'flex-start' }) => $justify};
  ${({ $position }) => $position && `position: ${$position};`}
  ${({ $background }) => $background && `background: ${cssVar($background)};`}
  ${({ $flexWrap }) => $flexWrap && `flex-wrap: ${$flexWrap};`}
  ${({ $zIndex }) => $zIndex !== undefined && `z-index: ${$zIndex};`}
  ${({ $fullWidth }) => $fullWidth && `width: 100%;`}

  ${({ $direction2xl }) => {
    if (!$direction2xl) return '';

    return mediaQuery(
      '2xl',
      css`
        flex-direction: ${$direction2xl};
      `
    );
  }}

  ${({ $directionXl }) => {
    if (!$directionXl) return '';

    return mediaQuery(
      'xl',
      css`
        flex-direction: ${$directionXl};
      `
    );
  }}

  ${({ $directionLg }) => {
    if (!$directionLg) return '';

    return mediaQuery(
      'lg',
      css`
        flex-direction: ${$directionLg};
      `
    );
  }}

  ${({ $directionMd }) => {
    if (!$directionMd) return '';

    return mediaQuery(
      'md',
      css`
        flex-direction: ${$directionMd};
      `
    );
  }}

  ${({ $directionSm }) => {
    if (!$directionSm) return '';

    return mediaQuery(
      'sm',
      css`
        flex-direction: ${$directionSm};
      `
    );
  }}

  ${borderStyles}
  ${columnStyles}
  ${spacingStyles}
  ${maxWidthStyles}
  ${visibilityStyles}
  ${orderStyles}
`;
